<script lang="ts">
	import type { UploadedFile } from "../../../core/schema/UploadedFile.js";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import type { ActionReturn } from "svelte/action";
	import * as Glide from "@glidejs/glide";
	import { disableGlidePerSlideAmount } from "../utils/disableGlidePerSlideAmount.js";
	import Paginator from "./Paginator.svelte";

	export let photoGallery: UploadedFile[];
	export let thumbnailImage: UploadedFile;

	let currentSlide = 0;

	function glide(element: HTMLDivElement): ActionReturn {
		const glideOptions = {
			type: "carousel",
			startAt: 0,
			focusAt: 0,
			perView: 1,
			autoplay: false,
			hoverpause: false,
			animationDuration: 650,
			animationTimingFunc: "ease-in-out",
			keyboard: true,
			cloningRatio: 2,
		} satisfies Partial<Glide.Options>;

		// eslint-disable-next-line new-cap
		const glide = new Glide.default(element, glideOptions).mount();
		glide.on("run", () => {
			currentSlide = glide.index;
		});
		glide.on("resize", () => {
			disableGlidePerSlideAmount(glide, element);
		});

		return {
			destroy(): void {
				glide.destroy();
			},
		};
	}
</script>

{#if photoGallery.length > 1}
	<div class="flex w-full max-w-[34.688rem] flex-col" use:glide>
		<div class="border-gray flex h-[34.688rem] w-full max-w-[34.688rem] items-center justify-center border">
			<div class="mx-auto h-[27.313rem] w-full max-w-[34.688rem]">
				<div class="glide__track relative w-full max-w-[34.688rem] overflow-hidden" data-glide-el="track">
					<div class="glide__slides flex">
						{#each photoGallery as image, index}
							<div class="glide__slide">
								<DynamicPicture
									{image}
									width={553}
									height={437}
									bucket="storage"
									loading={index > 0 ? "lazy" : "eager"}
									alt={image.title ?? ""}
									imgClass="w-full object-cover h-[27.313rem] w-full max-w-[34.688rem]"
								/>
							</div>
						{/each}
					</div>
				</div>
			</div>
		</div>
		<Paginator
			visibleSlides={[currentSlide + 1]}
			{currentSlide}
			perView={1}
			itemsLength={photoGallery.length}
			class="max-w-[70%] border-t-0"
		/>
	</div>
{:else}
	<div class="border-gray flex h-[34.688rem] w-full max-w-[34.688rem] items-center justify-center border">
		<DynamicPicture
			image={photoGallery[0] ?? thumbnailImage}
			width={1920}
			height={1080}
			bucket="storage"
			loading="eager"
			alt={(photoGallery[0] ?? thumbnailImage).title ?? ""}
			imgClass="w-full h-[27.313rem] object-contain"
		/>
	</div>
{/if}
